import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AuthPage from "@/pages/AuthPage";
import TodayPage from "@/pages/TodayPage";
import CalendarPage from "@/pages/CalendarPage";
import StatsPage from "@/pages/StatsPage";
import PatternsPage from "@/pages/PatternsPage";
import CommunityPage from "@/pages/CommunityPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import ProfilePage from "@/pages/ProfilePage";
import SharedDayPage from "@/pages/SharedDayPage";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F0E0C]">
      <div className="text-center">
        <div className="w-10 h-10 border border-[#CFA66A] mx-auto mb-4 flex items-center justify-center">
          <span className="font-mono text-[#CFA66A] text-xs">FJ</span>
        </div>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#A39A8E]">
          Loading...
        </p>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/" replace />;
  return children;
}

function Public({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user && user !== false) return <Navigate to="/today" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <Public>
                  <AuthPage />
                </Public>
              }
            />
            <Route
              path="/today"
              element={
                <Protected>
                  <TodayPage />
                </Protected>
              }
            />
            <Route
              path="/calendar"
              element={
                <Protected>
                  <CalendarPage />
                </Protected>
              }
            />
            <Route
              path="/stats"
              element={
                <Protected>
                  <StatsPage />
                </Protected>
              }
            />
            <Route
              path="/patterns"
              element={
                <Protected>
                  <PatternsPage />
                </Protected>
              }
            />
            <Route path="/share/:token" element={<SharedDayPage />} />
            <Route
              path="/community"
              element={
                <Protected>
                  <CommunityPage />
                </Protected>
              }
            />
            <Route
              path="/leaderboard"
              element={
                <Protected>
                  <LeaderboardPage />
                </Protected>
              }
            />
            <Route
              path="/profile"
              element={
                <Protected>
                  <ProfilePage />
                </Protected>
              }
            />
            <Route
              path="/u/:handle"
              element={
                <Protected>
                  <ProfilePage />
                </Protected>
              }
            />
            <Route
              path="/profile/:handle"
              element={
                <Protected>
                  <ProfilePage />
                </Protected>
              }
            />
            <Route
              path="/pricing"
              element={
                <Protected>
                  <PricingPage />
                </Protected>
              }
            />
            <Route
              path="/payment/success"
              element={
                <Protected>
                  <PaymentSuccessPage />
                </Protected>
              }
            />
            <Route
              path="/payment/cancel"
              element={
                <Protected>
                  <PaymentCancelPage />
                </Protected>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
